import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackPixel } from '../lib/metaPixel';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
}
const CHECKOUT_URL = 'https://www.recursohub.com/cart/48494859550912:1';
export function CTAButton({
  text = 'QUIERO EL KIT AHORA',
  href = CHECKOUT_URL,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    trackPixel('InitiateCheckout', {
      content_name: 'Kit Anti-Aburrimiento',
      currency: 'ARS',
      value: 12990
    });
  };
  return <motion.a href={href} onClick={handleClick} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`group relative overflow-hidden inline-flex items-center justify-center gap-3 bg-accent-500 hover:bg-accent-600 text-white font-display font-bold text-lg md:text-2xl py-3 md:py-4 px-6 md:px-8 rounded-full shadow-[0_0_40px_rgba(249,115,22,0.4)] hover:shadow-[0_0_60px_rgba(249,115,22,0.6)] transition-all duration-300 ${className}`} data-id="element-6">
      <span data-id="element-7">{text}</span>
      <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-8" />

      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-[shimmer_1.5s_infinite] rounded-full" data-id="element-9" />
    </motion.a>;
}